// @flow
import * as React from 'react';

import { withRouter } from 'app/context/Router';
import AdminAutoMessageDetailContainer from './AdminAutoMessageDetailContainer';
import AdminAutoMessageDetailView from './AdminAutoMessageDetailView';

type Props = {
  viewingOrgUuid: string,
  params: {
    uuid: string,
    groupCode: string,
  },
  router: *,
};

class AdminAutoMessageDetail extends React.Component<Props, void> {
  handleRedirectToMessage = (messageUuid: string) => {
    const {
      router,
      params: { groupCode },
    } = this.props;
    router.push(`/classes/${groupCode}/settings/organization/auto_messages/${messageUuid}`);
  };

  handleRedirectToList = () => {
    const {
      router,
      params: { groupCode },
    } = this.props;
    router.push(`/classes/${groupCode}/settings/organization/auto_messages`);
  };

  render() {
    const {
      viewingOrgUuid,
      params: { uuid, groupCode },
    } = this.props;

    return (
      <AdminAutoMessageDetailContainer messageUuid={uuid}>
        {props => (
          <AdminAutoMessageDetailView
            viewingOrgUuid={viewingOrgUuid}
            onRedirectToMessage={this.handleRedirectToMessage}
            onRedirectToList={this.handleRedirectToList}
            urlSlug={`/classes/${groupCode}/settings/organization`}
            {...props}
          />
        )}
      </AdminAutoMessageDetailContainer>
    );
  }
}

export { AdminAutoMessageDetail };

export default withRouter(AdminAutoMessageDetail);
